// extracted by mini-css-extract-plugin
export default {"mask":"Base_mask__ODnLZ","area":"Base_area__IR1Sv","modal":"Base_modal__NIy2A","close":"Base_close__4GGuN","title":"Base_title__11fOu","content":"Base_content__rjibC"};